/*Author - Subhalakshmi S
Date - 18-10-2024
Task - UI/UX:blog */
import React, { useContext, useEffect, useState } from "react";
import AdminLayout from "../../../components/layouts/adminLayout";
import AdminPageContainer from "../../../components/AdminPageContainer";
import AdminPageHeader from "../../../components/AdminPageHeader";
import { useNavigate } from "react-router";
import { Tabs, Tab } from "react-bootstrap";
import BlogLists from "./BlogLists";
import BlogCategory from "./BlogCategory";
export default function Blogs() {
  const navigate = useNavigate();
  return (
    <AdminLayout test="active">
      <AdminPageContainer>
        <div id="main" role="main">
          <div id="content">
            <div>
              <ol className="breadcrumb">
                <li className="breadcrumb-item ">
                  <a
                    style={{
                      color: "blue",
                      cursor: "pointer",
                    }}
                    onClick={() => navigate("/system-admin/license-master")}
                    onKeyDown={() => navigate("/system-admin/license-master")}
                  >
                    Home
                  </a>
                </li>
                <li className="breadcrumb-item active">Website Content Management</li>

                <li className="breadcrumb-item active">Blogs</li>
              </ol>
            </div>
            <div className="row">
              <div className="">
                <div className="card card-sm card-shadow mb-3 ">
                  <div className="card-body">
                    <div>
                      <AdminPageHeader title="Blogs" />
                      <Tabs
                        defaultActiveKey="blogs"
                        transition={false}
                        unmountOnExit={true}
                        mountOnEnter={true}
                        className=" bordered p-0 m-0"
                      >
                        <Tab
                          eventKey="blogs"
                          title="Blogs"
                          tabClassName="rounded-0"
                        >
                          <BlogLists />
                        </Tab>
                        <Tab
                          eventKey="category"
                          title="Category"
                          tabClassName="rounded-0 text-decoration-none"
                        >
                          <BlogCategory />
                        </Tab>
                      </Tabs>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </AdminPageContainer>
    </AdminLayout>
  );
}
